import React from 'react';
import { Link } from 'react-router-dom';
import auth from '../../firebase.init';
import { signOut } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { BsFillMenuButtonWideFill } from "react-icons/bs";

const Navbar = () => {
    const [user] = useAuthState(auth);
    const handleLogOut = () => {
        signOut(auth)
        localStorage.removeItem('accessToken')
    }
    const myNav = <>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/about'>About</Link></li>
        <li><Link to='/appointment'>Appointment</Link></li>
        <li><Link to='/reviews'>Reviews</Link></li>
        <li><Link to='/contact'>Contact Us</Link></li>
        {user && <li><Link to='/Dashboard'>Dashboard</Link></li>}
        {user ? <button onClick={handleLogOut} className="btn btn-ghost">Log out</button> :
        <li><Link to='/login'>Login</Link></li>
        }
    </>
    return (
        <div className="navbar">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-ghost md:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {myNav}
                    </ul>
                </div>
                <Link className="btn btn-ghost normal-case text-2xl" to='/'>Doctors's Portal</Link>
            </div>
            <div className="navbar-center hidden md:flex">
                <ul className="menu menu-horizontal p-0">
                    {myNav}
                </ul>
            </div>
            <div className="navbar-end">
                <label tabIndex="1" htmlFor="my-drawer-2" className="btn btn-ghost md:hidden">
                    <BsFillMenuButtonWideFill />
                    {/* <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg> */}
                </label>
            </div>
        </div>
    );
};

export default Navbar;